/**
 * Texto de una linea. Cubre `char`, `email` y `url`.
 *
 * El `type` del input no es cosmetico: en un celular decide que teclado aparece,
 * y es lo que hace que cargar 40 emails de propietarios sea tolerable.
 */

import { controlClass } from '@/components/fields/controls';
import { ReadonlyOutput } from '@/components/fields/FieldDisplay';
import type { FieldInputProps } from '@/components/fields/types';

const TIPOS_HTML: Record<string, string> = {
  email: 'email',
  url: 'url',
  char: 'text',
};

export function CharField({
  id,
  meta,
  value,
  onChange,
  readonly,
  required,
  invalid,
  describedBy,
}: FieldInputProps) {
  if (readonly) {
    return <ReadonlyOutput id={id} meta={meta} value={value} {...(describedBy === undefined ? {} : { describedBy })} />;
  }

  const tipo = TIPOS_HTML[meta.widget ?? meta.type] ?? TIPOS_HTML[meta.type] ?? 'text';

  return (
    <input
      id={id}
      type={tipo}
      className={controlClass(invalid)}
      value={typeof value === 'string' ? value : value === null || value === undefined ? '' : String(value)}
      required={required}
      aria-required={required || undefined}
      aria-invalid={invalid || undefined}
      aria-describedby={describedBy}
      maxLength={meta.max_length}
      autoComplete="off"
      onChange={(evento) => {
        // Cadena vacia -> `null` solo si el campo admite nulos; si no, el backend
        // espera "" y mandarle null seria un error de validacion evitable.
        const texto = evento.target.value;
        onChange(texto === '' && meta.null === true ? null : texto);
      }}
    />
  );
}
